module.exports = __webpack_public_path__ + "static/circle2-ab1731d4411c10a09c68fce99437fd16.png";